import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CustomTranslateLoader } from '@services/custom.loader';
import { SelectDropDownModule } from './_customComponent/ngx-select-dropdown/ngx-select-dropdown.module';
import { TrueFalseValueDirective } from './_directives/trueFalseValue.directive';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgxMegaSimpleDragDropListModule } from 'ngx-mega-simple-drag-drop-list';
import { CountdownModule } from 'ngx-countdown';
import { NgxPrintModule } from 'ngx-print';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { AppLeftMenuComponent } from './_layout/app-leftmenu/app-leftmenu.component';
import { SearchFilterPipe } from './filterdata.pipe';
import { CommonService } from '@services/app.common.service';
import { AlertService } from '@services/alert.service';
import { ClickStopPropagationDirective } from './_directives/stopPropogation.directive';
import { SendEmailModalComponent } from './_components/sendEmailModal/sendEmailModal.component'; //this is not being used anywhere
import { ArraySortPipe } from './orderby.pipe';
import { NgbModule, NgbDateAdapter, NgbDateNativeAdapter, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { PrintAndExportComponent } from './_components/printAndExport/printAndExport.component';
import { AppJTContainerComponent } from './_customComponent/_jtContainer/app-jt-container.component';
import { AppHorizontalFormComponent } from './_customComponent/_froms/app-horizontal-form/app-horizontal-form.component';
import { AppVerticalFormComponent } from './_customComponent/_froms/app-vertical-form/app-vertical-form.component';
import { JTTabSetComponent } from './_customComponent/_tabs/app-jt-tab/app-jt-tabset.component';
import { JTTabComponent } from './_customComponent/_tabs/app-jt-tab/app-jt-tab.component';
import { AppJTActionButtonComponent } from './_customComponent/_actionButtons/app-action-button.component';
import { AppJTActionButtonModalComponent } from './_customComponent/_actionButtonsModal/app-action-button-modal.component';
import { AppJTCardComponent } from './_customComponent/_cards/app-jt-card.component';
import { AppHorizontalFormForTabComponent } from './_customComponent/_froms/app-horizontal-form/app-horizontal-form-for-tab';
import { AppListPageComponent } from './_customComponent/_pages/app-jt-list.component';
import { AppPageTitleComponent } from './_layout/app-pageTitle/app-pageTitle.component';
import { AppAddPageComponent } from './_customComponent/_pages/app-jt-add-page/app-jt-add.component';
import { AppJTIndexComponent } from './_customComponent/_pages/app-jt-index-page/app-jt-index-page.component';
import { AppModalPageComponent } from './_customComponent/_pages/app-jt-modal-page/app-jt-modal.component';
import { AppModalHorizontalFormComponent } from './_customComponent/_froms/app-horizontal-form/app-modal-horizontal-form.component';
import { LookupDataViewComponent } from './_components/app-LookupDataView/app-LookupDataView.component';

import { JTTabSetModalComponent } from './_customComponent/_tabs/app-jt-tab-modal/app-jt-tabset-modal.component';
import { JTTabModalComponent } from './_customComponent/_tabs/app-jt-tab-modal/app-jt-tab-modal.component';
//import { DynamicFormModule } from './_modules/dynamicForm/dynamicForm.module';
//import { DynamicFormComponent } from './_modules/dynamicForm/components/dynamicForm/dynamicForm.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { GroupByPipe } from './groupby.pipe';
import { AppFilterMenuComponent } from './_layout/app-filtermenu/app-filter-menu.component';
import { AlertComponent } from './_directives';
import { AppReportListPageComponent } from './_customComponent/_pages/app-jt-reports.component';
import { AppModalHorizontalFormForTabComponent } from './_customComponent/_froms/app-horizontal-form/app-modal-horizontal-form-for-tab';
import { ConfirmationModalComponent } from './_components/confirmationmodal/confirmation-modal.component';
import { AppDataViewComponent } from './_components/app-DataView/app-DataView.component';

import { AppCommonTableComponent } from './_components/app-CommonTable/app-CommonTable.component';
import { CheckListComponent } from './_components/checkList/checkList.component';
import { StarterFormComponent } from './_components/starterForm/starterForm.component';
import { PreviewFormSectionComponent } from './_components/previewForm/previewForm.component';
import { ScriptLoaderComponent } from './_components/scriptLoader/scriptLoader.component';
import { SumPipe } from './sum.pipe';
import { CKEditorModule } from 'ng2-ckeditor';
import { DynamicScriptLoaderService } from '@services/dynamicScriptLoaderService';
import { AutoCompleteModalComponent } from './_components/app-AutoCompleteModal/app-AutoCompleteModal.component';
import { AutoCompleteComponent } from './_components/app-AutoComplete/app-AutoComplete.component';
import { StaticIndexComponent } from './_components/staticIndex/staticIndex.component';
//import { AssessmentFormTestComponent } from './_components/assessmentFormTest/assessmentFormTest.component';
import { SvgIconModule } from './_customComponent/Icons/_svg/app-jt-svg-icon.module';
import { JtHttpInterceptor } from './_interceptor/http.interceptor';
import { AngularMyDatePickerModule } from 'angular-mydatepicker';
import { setBootStrapColumnDirective } from './_directives/setBootStrapColumnClass.directive';
import { AppDatePickerComponent } from './_components/app-DatePicker/app-DatePicker.component';
import { FormDateFormatter } from './FormDateFormatter';
import { FormatService } from '@services/app-formatservice';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { SendEmailModalGACsComponent } from './_components/sendEmailModalGapAndConcern/sendEmailModalGACs.component';
//import { GradeFareAssignToJobModalModule } from './jobsAndTalents/fdm/gradeFare/_gradefFareActions/assignToJobModal/gradeFareAssignToJobModal.module';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { ExcelExportModalModule } from './_components/printAndExport/excel-export-modal/excel-export-modal.module';
import { DateVoyageCareIntegrationModule } from './_components/starterForm/_integration/voyage-care/data-voyage-care-integration.module';
import { UpperCasePipe } from './pipes/upper-case.pipe';
import { ItrentintegrationModule } from './_components/starterForm/_integration/itrent-integration/itrent-integration.module';
import { DataMigrationIntegrationModule } from './_components/starterForm/_integration/data-migration-integration.module';
import { DataViewCustomSearchComponent } from './_components/dataview-custom-search/search.component';
import { TalentPoolHeaderMenuComponent } from './_layout/talent-pool-header-menu/talent-pool-header-menu.component';
import { RatingModule } from '@customcomponent/ng-star-rating/lib/rating.module';
import { ExtendDatePipe } from './pipes/date.pipe';
import { OrdinalPipe } from './ordinal.pipe';
import { AuthorizationWorkFlowDeleteConfirmation } from '../settings/shared/authorizationWorkFlow/delete-confirmation.component';
const routes: Routes = [
  { path: 'PrintPreview', component: PrintAndExportComponent }
];


@NgModule({
  imports: [
   // DynamicFormModule,
    // GradeFareAssignToJobModalModule,
    CommonModule,
    RouterModule,
    AngularMyDatePickerModule,
    ExcelExportModalModule,
    ReactiveFormsModule,
    FormsModule,
    SvgIconModule,
    SelectDropDownModule,
    CKEditorModule,
    CountdownModule,
    InfiniteScrollModule,
    NgxPrintModule,
    DataMigrationIntegrationModule,
    NgbModule,
    NgxMegaSimpleDragDropListModule,
    DateVoyageCareIntegrationModule,
    ItrentintegrationModule,
    ModalModule.forRoot(),
    RouterModule.forChild(routes),
    TooltipModule.forRoot(),
    TypeaheadModule.forRoot(),
    BsDropdownModule.forRoot(),
    AccordionModule.forRoot(),
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useClass: CustomTranslateLoader,
        deps: [HttpClient]
      }
    }),
    RatingModule

  ],
  declarations: [
    AppLeftMenuComponent,
    AppDataViewComponent,
    AppCommonTableComponent,
    SearchFilterPipe,
    ArraySortPipe,
    GroupByPipe,
    SafeHtmlPipe,
    setBootStrapColumnDirective,
    TrueFalseValueDirective,
    ClickStopPropagationDirective,
    AppDatePickerComponent,
    SendEmailModalComponent,
    PrintAndExportComponent,
    AppJTContainerComponent,
    AppHorizontalFormComponent,
    AppVerticalFormComponent,
    //AssessmentFormTestComponent,
    JTTabComponent,
    JTTabSetComponent,
    AppJTActionButtonComponent,
    AppJTActionButtonModalComponent,
    AppJTCardComponent,
    AppHorizontalFormForTabComponent,
    AppListPageComponent,
    AppAddPageComponent,
    AppJTIndexComponent,
    AppModalPageComponent,
    AppModalHorizontalFormComponent,
    AppJTIndexComponent,
    LookupDataViewComponent,
    AppPageTitleComponent,
    JTTabSetModalComponent,
    JTTabModalComponent,
    AppFilterMenuComponent,
    AlertComponent,
    AppReportListPageComponent,
    AppModalHorizontalFormForTabComponent,
    ConfirmationModalComponent,
    StarterFormComponent,
    PreviewFormSectionComponent,
    ScriptLoaderComponent,
    SumPipe,
    AutoCompleteModalComponent,
    AutoCompleteComponent,
    StaticIndexComponent,
    SendEmailModalGACsComponent,
    UpperCasePipe,
    TalentPoolHeaderMenuComponent,
    DataViewCustomSearchComponent,
    OrdinalPipe,
    ExtendDatePipe,
    AuthorizationWorkFlowDeleteConfirmation
  ],
  exports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    AppLeftMenuComponent,
    AppDataViewComponent,
    AppCommonTableComponent,
    SearchFilterPipe,
    ArraySortPipe,
    GroupByPipe,
    SafeHtmlPipe,
    TrueFalseValueDirective,
    ClickStopPropagationDirective,
    SendEmailModalComponent,
    AppDatePickerComponent,
    setBootStrapColumnDirective,
    // AssessmentFormTestComponent,
    PrintAndExportComponent,
    AppJTContainerComponent,
    PreviewFormSectionComponent,
    AppHorizontalFormComponent,
    AppVerticalFormComponent,
    JTTabComponent,
    JTTabSetComponent,
    AppJTActionButtonComponent,
    AppJTActionButtonModalComponent,
    AppJTCardComponent,
    AppHorizontalFormForTabComponent,
    AppListPageComponent,
    AppAddPageComponent,
    AppJTIndexComponent,
    AppModalPageComponent,
    AppModalHorizontalFormComponent,
    AppJTIndexComponent,
    LookupDataViewComponent,
    JTTabSetModalComponent,
    JTTabModalComponent,
    NgxPrintModule,
    AppPageTitleComponent,
    InfiniteScrollModule,
    BsDropdownModule,
    JTTabModalComponent,
   // DynamicFormComponent,
    StarterFormComponent,
    ScriptLoaderComponent,
    SumPipe,
    UpperCasePipe,
    SendEmailModalGACsComponent,
    DataViewCustomSearchComponent,

    TalentPoolHeaderMenuComponent,
    TranslateModule,   
    OrdinalPipe,
    ExtendDatePipe,
    AuthorizationWorkFlowDeleteConfirmation
  ],
  bootstrap: [],
  providers: [
    CommonService
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class ShareModule {

  constructor(private translate: TranslateService, private common: CommonService) {
    if (!this.translate.currentLang) {
      translate.setDefaultLang(common.GetFromLocalStorage('lang'));
      translate.use(common.GetFromLocalStorage('lang'));
    }
  }

}

